import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

import { ListBoxFilterPipe } from './list-box-filter.pipe';

@Component({
  selector: 'atn-list-box',
  templateUrl: './list-box.component.html',
  styleUrls: ['./list-box.component.scss'],
  providers: [ListBoxFilterPipe]
})
export class ListBoxComponent implements OnInit {
  @Input() name: string;
  @Input() outputField: string;
  @Input() removeQuestion: string = '¿Esta seguro de que desea borrarlo?';
  @Input() service: any;
  @Input() sortable: boolean = false;
  @Input() seeker: boolean = false;
  @Input() duplicateOption: boolean = true;

  loading: boolean = false;
  items: Array<any> = [];
  itemsFiltered: Array<any> = [];
  selectedItemFiltered: any = null;
  selectedItemId: string = null;
  draggedItem: number = null;
  searchString: string = null;
  showForm: boolean = false;
  showActive: boolean = false;

  constructor(private listBoxFilterPipe: ListBoxFilterPipe) {}

  ngOnInit() {
    this.reload();
  }

  @HostListener('document:keydown', ['$event'])
  detectShortcut(e) {
    if ((e.ctrlKey) && (e.altKey)) {
      if ([65].indexOf(e.keyCode) !== -1) {
        e.preventDefault();
      }

      switch (e.keyCode) {
        case 65: this.addItem(); break; // Ctrl + Alt + A
      }
    }
  }

  hideForm() {
    this.setSelectedItem(null);
    this.showForm = false;
  }

  hideFormAndReload() {
    this.hideForm();
    this.reload();
  }

  reload(changeLoading = true) {
    if (changeLoading) {
      this.loading = true;
    }

    this.service.getAll().subscribe(items => {
      this.items = items;
      this.itemsFiltered = this.items.slice();
      if (this.items[0]) {
        if (typeof this.items[0].active !== 'undefined') {
          this.showActive = true;
        }
      }
      this.filterItems();
      this.orderItems();
      this.loading = false;
    });
  }

  orderItems() {

    if (!this.sortable) {
      this.itemsFiltered.sort((itemA, itemB) => {
        const a = itemA[this.outputField] ? itemA[this.outputField].toLowerCase() : '';
        const b = itemB[this.outputField] ? itemB[this.outputField].toLowerCase() : '';

        if ( a > b) {
          return 1;
        } else if (b > a) {
          return -1;
        } else {
          return 0;
        }
      });
    }
  }

  filterItems() {
    if (this.searchString !== null) {
      this.itemsFiltered = this.listBoxFilterPipe
        .transform(this.items, this.searchString, this.outputField)
      ;

      if (
        (this.selectedItemFiltered !== null) &&
        (this.itemsFiltered.indexOf(this.selectedItemFiltered) === -1)
      ) {
        this.setSelectedItem(null);
        this.showForm = false;
      }
    }
  }

  selectItem(item) {
    this.setSelectedItem(item);
    this.showForm = true;
  }

  addItem() {
    this.setSelectedItem(null);
    this.showForm = true;
  }

  removeItem(e: Event, item) {
    e.stopPropagation();

    if (confirm(this.removeQuestion)) {
      if (this.selectedItemId === item._id) {
        this.setSelectedItem(null);
        this.showForm = false;
      }

      this.loading = true;

      this.service.remove(item._id).subscribe(() => {
        this.reload(false);
      });
    }
  }

  duplicateItem(e: Event, item) {
    e.stopPropagation();
    this.loading = true;

    this.service.duplicate(item._id).subscribe(() => {
      this.reload(false);
    });
  }

  selectPrevItem() {
    const pos = this.itemsFiltered.indexOf(this.selectedItemFiltered);

    if (pos !== -1) {
      this.moveTo(pos - 1);
    }
  }

  selectNextItem() {
    const pos = this.itemsFiltered.indexOf(this.selectedItemFiltered);

    if (pos !== -1) {
      this.moveTo(pos + 1);
    }
  }

  dragItem(i: number) {
    setTimeout(() => {
      this.draggedItem = i;
      this.setSelectedItem(null);
      this.showForm = false;
    }, 100);
  }

  dropItem(e: Event, i: number) {
    e.stopPropagation();
    this.loading = true;
    this.itemsFiltered = this.reorderItems(this.itemsFiltered, this.draggedItem, i);
    this.draggedItem = null;

    this.service.saveMultiple(this.itemsFiltered).subscribe(items => {
      this.reload(false);
    });
  }

  @HostListener('document:click')
  cancelDrag() {
    if (this.draggedItem !== null) {
      this.draggedItem = null;
    }
  }

  private setSelectedItem(item: any) {
    this.selectedItemFiltered = item;
    this.selectedItemId = (item === null) ? null : item._id;
  }

  private moveTo(i: number) {
    if ((i !== -1) && (i >= 0) && (i < this.itemsFiltered.length)) {
      this.setSelectedItem(this.itemsFiltered[i]);
    }
  }

  private reorderItems(items: Array<any>, positionStart: number = null, positionEnd: number = null) {
    if (positionStart !== positionEnd) {
      const itemsCloned = items.slice();
      const itemSelected = items[positionStart];
      items = [];

      itemsCloned.forEach((item, i) => {
        if (positionStart > positionEnd) {
          if ((i > positionStart) || (i < positionEnd)) {
            items[i] = item;
          } else if (i === positionEnd) {
            items[i] = itemSelected;
            items[i + 1] = item;
          } else if (i !== positionStart) {
            items[i + 1] = item;
          }
        } else {
          if ((i < positionStart) || (i > positionEnd)) {
            items[i] = item;
          } else if (i === positionEnd) {
            items[i] = itemSelected;
            items[i - 1] = item;
          } else if (i !== positionStart) {
            items[i - 1] = item;
          }
        }
      });
    }

    items = items.map((x, y) => {
      x.position = y + 1;

      return x;
    });

    return items;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/list-box/list-box.component.ts